module.exports = __webpack_public_path__ + "img/img_2.d261d41c.png";